import { api } from "./api";

export interface SparklinePoint {
  date: string; // ISO YYYY-MM-DD
  priceEurCents: number;
}

export interface SparklineResponse {
  positionId: string;
  days: number;
  points: SparklinePoint[];
}

export interface DetailChartPoint {
  date: string;
  positionPriceEurCents: number;
  groupIndexPercent: number; // 100 % am Perioden-Start
}

export interface DetailTransaction {
  date: string;
  type: "BUY" | "SELL" | "DIVIDEND" | "TRANSFER";
  shares: number | null;
  amountCents: number;
}

export type DetailPeriod = "30d" | "90d" | "since-buy";

export interface PositionDetailResponse {
  positionId: string;
  name: string;
  isin: string | null;
  category: "FELS" | "RAKETE" | null;
  valueCents: number;
  gainLossPercent: number | null;
  depotSharePercent: number;
  avgCostCents: number;
  period: DetailPeriod;
  chart: DetailChartPoint[];
  transactions: DetailTransaction[];
}

export const otterfolioDetailApi = {
  sparkline: (positionId: string, days = 30) =>
    api<SparklineResponse>(`/otterfolio/positions/${positionId}/sparkline?days=${days}`),
  detail: (positionId: string, period: DetailPeriod) =>
    api<PositionDetailResponse>(`/otterfolio/positions/${positionId}/detail?period=${period}`),
};
